import script from "./BestellenIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BestellenIndex.vue?vue&type=script&setup=true&lang=js"

import "./BestellenIndex.vue?vue&type=style&index=0&id=5ec99b50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec99b50"]])

export default __exports__